import { LoginForm } from './Form'
import './index.css'

export const Login = () => {
  return (
    <div className="layout">
      <div className="container">
        <div style={{ height: 60, marginBottom: 100, textAlign: 'center' }}>
          <img src="/images/logo.sygo.png" height="80px" alt="logo" />
        </div>
        <div>
          <LoginForm />
        </div>
      </div>
    </div>
  )
}
